import { apiClient, normalizeBearer } from "../Lib/Config/api.config";
import { APP_KEY, NETWORK_ERROR } from "../Lib/Consts";
import store from "../Lib/Store";
import { setSession, userLoggedOut } from "../Lib/Store/Slices/AuthSlice";
import { decryptData, encryptData } from "../Lib/Utils";
import NotificationController from "./NotificationController";

class AuthController {
  static signIn(data = { email: "", password: "" }) {
    return new Promise((resolve, reject) => {
      apiClient({
        url: "/api/admin/login",
        method: "POST",
        data,
      })
        .then((res) => {
          if (res?.data?.success) {
            resolve(res?.data?.data);
          } else {
            reject(res?.data?.error?.message);
          }
        })
        .catch((err) => {
          reject(NETWORK_ERROR);
        });
    });
  }

  static notificationPreferences(data = { newProvider: false }) {
    return new Promise((resolve, reject) => {
      apiClient({
        url: "/api/admin/update-notification-pref",
        method: "POST",
        data,
      })
        .then((res) => {
          if (res?.data?.success) {
            resolve(res?.data?.data);
          } else {
            reject(res?.data?.error?.message);
          }
        })
        .catch((err) => {
          reject(NETWORK_ERROR);
        });
    });
  }

  static requestTwoFactorSetup(twoFactorToken) {
    return new Promise((resolve, reject) => {
      apiClient({
        url: "/api/admin/2fa/setup",
        method: "POST",
        skipSessionAuth: true,
        headers: {
          Authorization: normalizeBearer(twoFactorToken),
        },
      })
        .then((res) => {
          if (res?.data?.success) {
            resolve(res?.data?.data);
          } else {
            reject(res?.data?.error?.message);
          }
        })
        .catch((err) => {
          reject(NETWORK_ERROR);
        });
    });
  }

  static confirmTwoFactorSetup(data = { token: "" }, twoFactorToken) {
    return new Promise((resolve, reject) => {
      apiClient({
        url: "/api/admin/2fa/setup/verify",
        method: "POST",
        skipSessionAuth: true,
        data,
        headers: {
          Authorization: normalizeBearer(twoFactorToken),
        },
      })
        .then((res) => {
          if (res?.data?.success) {
            resolve(res?.data?.data);
          } else {
            reject(res?.data?.error?.message);
          }
        })
        .catch((err) => {
          reject(NETWORK_ERROR);
        });
    });
  }

  static verifyTwoFactorLogin(data = { token: "" }, twoFactorToken) {
    return new Promise((resolve, reject) => {
      apiClient({
        url: "/api/admin/2fa/login/verify",
        method: "POST",
        skipSessionAuth: true,
        data,
        headers: {
          Authorization: normalizeBearer(twoFactorToken),
        },
      })
        .then((res) => {
          if (res?.data?.success) {
            resolve(res?.data?.data);
          } else {
            reject(res?.data?.error?.message);
          }
        })
        .catch((err) => {
          reject(NETWORK_ERROR);
        });
    });
  }

  static startTwoFactorReconfigure(data = { currentToken: "" }) {
    return new Promise((resolve, reject) => {
      apiClient({
        url: "/api/admin/2fa/reconfigure",
        method: "POST",
        data,
      })
        .then((res) => {
          if (res?.data?.success) {
            resolve(res?.data?.data);
          } else {
            reject(res?.data?.error?.message);
          }
        })
        .catch((err) => {
          reject(NETWORK_ERROR);
        });
    });
  }

  static confirmTwoFactorReconfigure(data = { token: "" }) {
    return new Promise((resolve, reject) => {
      apiClient({
        url: "/api/admin/2fa/reconfigure/confirm",
        method: "POST",
        data,
      })
        .then((res) => {
          if (res?.data?.success) {
            resolve(res?.data?.data);
          } else {
            reject(res?.data?.error?.message);
          }
        })
        .catch((err) => {
          reject(NETWORK_ERROR);
        });
    });
  }

  static getPersistedCredentials = () => {
    let strSessionData = localStorage?.getItem(APP_KEY);
    if (strSessionData) {
      const decryptedData = decryptData(
        strSessionData,
        import.meta.env.VITE_SECRET_KEY
      );
      console.log({ decryptedData }, "@decryptedData");
      return decryptedData;
    } else {
      return null;
    }
  };

  static persistCredentials(data) {
    store.dispatch(setSession(data));
    const encryptedData = encryptData(data, import.meta.env.VITE_SECRET_KEY);
    console.log({ encryptedData }, "@encryptedData");
    localStorage?.setItem(APP_KEY, encryptedData);
  }

  static restorePersistedCredentials() {
    let persistedData = AuthController.getPersistedCredentials();
    console.log({ persistedData }, "@persistedData");
    if (persistedData) {
      store.dispatch(setSession(persistedData));
      return persistedData;
    } else {
      return false;
    }
  }

  static clearCredentials() {
    localStorage?.removeItem(APP_KEY);
  }

  static async logout() {
    const session = AuthController.getPersistedCredentials();

    console.log(session, "@logout session 1");
    session?.fcm_token &&
      (await NotificationController.removeFcmToken(
        session?.fcm_token,
        session?.user?._id
      ));
    console.log(session, "@logout session 2");
    store.dispatch(userLoggedOut());
    AuthController.clearCredentials();
  }

  static resetPassword(data = { password: "" }) {
    return new Promise((resolve, reject) => {
      apiClient({
        url: "/api/admin/reset-password",
        method: "POST",
        data,
      })
        .then((res) => {
          if (res?.data?.success) {
            resolve(res?.data?.data);
          } else {
            reject(res?.data?.error?.message);
          }
        })
        .catch((err) => {
          reject(NETWORK_ERROR);
        });
    });
  }
}

export default AuthController;
